var map = {
	"./2.0/gs.png": "bfb4",
	"./2.0/ks.png": "85d7",
	"./2.0/name-bg.png": "17bd",
	"./2.0/nh.png": "5705",
	"./2.0/shy-banner.png": "4c4b",
	"./2.0/side-kf-icon.png": "51e9",
	"./2.0/side-wx-icon.png": "989f",
	"./2.0/sjx.png": "9272",
	"./2.0/step1-1.png": "d52d",
	"./2.0/step1-2.png": "84d8",
	"./2.0/step1-3.png": "1cdb",
	"./2.0/step1-4.png": "7b10",
	"./2.0/step1-5.png": "3a9e",
	"./2.0/step2-1.png": "e4f6",
	"./2.0/step2-2.png": "2b94",
	"./2.0/step2-3.png": "83f5",
	"./2.0/tg.png": "5fa0",
	"./2.0/yszc.png": "6c62",
	"./2.0/yz.png": "b1d3",
	"./2.0/zn.png": "565e",
	"./2.0/zncs.png": "776b",
	"./about-m-banner.png": "fc35",
	"./about-us.png": "aeab",
	"./about/about-bg.png": "dad0",
	"./about/about-story-bg.png": "9293",
	"./about/company-introduction-bg.png": "46c2",
	"./about/qualification-img1.png": "37e8",
	"./about/qualification-img2.png": "2a8d",
	"./account-book-tax.png": "8152",
	"./advantage-bg.png": "8856",
	"./banner-r-l.png": "892a",
	"./banner-r-main.png": "e61f",
	"./banner-r-r.png": "8513",
	"./banner-r-shadow-1.png": "a42c",
	"./banner-r-shadow-2.png": "163c",
	"./banner-r-shadow-3.png": "f706",
	"./bill-review.png": "24e6",
	"./case-banner.png": "e9b8",
	"./case-left-arrow.png": "8103",
	"./case-m-banner.png": "9bef",
	"./case-qrcode.png": "0ae3",
	"./case-right-arrow.png": "9fcf",
	"./case-user-ava1.png": "fa80",
	"./case-user-ava2.png": "0cfb",
	"./case-user-ava3.png": "ad29",
	"./cp/yszc-sj-yy.png": "6f05",
	"./cp/yszc-sj.png": "579d",
	"./cp/yszc-zs.png": "d3bd",
	"./cp/zncs-sj-yy.png": "e804",
	"./cp/zncs-sj.png": "9028",
	"./cp/zncs-zs.png": "24c9",
	"./current.png": "452f",
	"./customer-slide-left.png": "7f43",
	"./customer-slide-right.png": "a5ed",
	"./dynamic-news.png": "ee19",
	"./financial-and-taxation.png": "ccb4",
	"./fiscal-consultation.png": "5d6e",
	"./footer-detail.png": "b75f",
	"./footer-gzh.png": "ee41b",
	"./footer-logo.png": "8bef",
	"./grid-backgound.png": "93ee",
	"./gshm/banner-big.png": "6a03",
	"./gshm/banner.png": "fe8c",
	"./gshm/icon-1.png": "0aec",
	"./gshm/icon-2.png": "e85e",
	"./gshm/icon-3.png": "b7ce",
	"./gshm/icon-4.png": "8bb4",
	"./gshm/step1-3.png": "508c",
	"./gshm/vs-img-mobile.png": "0658",
	"./gshm/vs-img.png": "53c3",
	"./gshm/xcxm.png": "4108",
	"./gshm/yszc-sj-2x.png": "d4c5",
	"./gshm/yszc-sj-m.png": "041d",
	"./gshm/yszc-sj-yy.png": "a282",
	"./gshm/yszc-sj.png": "af24",
	"./home/close.png": "fd29",
	"./home/go.png": "e117",
	"./home/loading.png": "9dad",
	"./home/refresh.png": "32cb",
	"./home/refresh@1x.png": "5357",
	"./home/validation.png": "8d19",
	"./hzhb/hzhb-zs.png": "1ddd3",
	"./hzhb/img1.png": "a280",
	"./hzhb/img10.png": "f43a",
	"./hzhb/img11.png": "ed1b",
	"./hzhb/img12.png": "0d4c",
	"./hzhb/img2.png": "36f2",
	"./hzhb/img3.png": "926a",
	"./hzhb/img4.png": "3b7a",
	"./hzhb/img5.png": "b49c",
	"./hzhb/img6.png": "1307",
	"./hzhb/img7.png": "4652",
	"./hzhb/img8.png": "0608",
	"./hzhb/img9.png": "77b9",
	"./industrial-and-commercial-inspection.png": "0861",
	"./intelligent-accounting.png": "a996",
	"./introduce-bg.png": "ed5b",
	"./introduce-pk-bg.png": "4cf7",
	"./introduce-special.png": "322b",
	"./invoice-management.png": "78a9",
	"./news-m-banner.png": "cf51",
	"./online-check.png": "6bb2",
	"./option.png": "976c",
	"./partner/competitiveness-bg.png": "43fb",
	"./partner/competitiveness-bg2.png": "6166",
	"./partner/concept-bg.png": "97c0",
	"./partner/concept-bg2.png": "8738",
	"./partner/difficulty.png": "f8e1",
	"./partner/dimension-bg.png": "0d79",
	"./partner/dimension-bg2.png": "8038",
	"./partner/industry-bg.png": "6619",
	"./partner/industry-bg2.png": "73b4",
	"./partner/mining-bg.png": "5dee",
	"./partner/mining-bg2.png": "3009",
	"./partner/process-icon1.png": "8211",
	"./partner/process-icon2.png": "9bd7",
	"./partner/process-icon3.png": "7c0c",
	"./partner/process-icon4.png": "69dd",
	"./partner/process-icon5.png": "638e",
	"./partner/process-icon6.png": "c0a6",
	"./partner/product-bg.png": "81ca",
	"./partner/product-bg2.png": "9461",
	"./partner/reason1.png": "b57f",
	"./partner/reason2.png": "2607",
	"./partner/reason3.png": "6b2b",
	"./partner/reason4.png": "61e0",
	"./partner/right-arrow.png": "84d7",
	"./partner/service-bg.png": "3e60",
	"./partner/service-bg2.png": "d3b6",
	"./partner/success.png": "dd9b",
	"./partner/threshold-img.png": "d0d1",
	"./partner/title.png": "77a8",
	"./payment.png": "db8a",
	"./price.png": "217a",
	"./product-five-1.png": "a9ab",
	"./product-five-2.png": "d9cf",
	"./product-five-3.png": "667d",
	"./product-four-0.png": "b6ec",
	"./product-m-banner.png": "71fa",
	"./product-m-bg.png": "3697",
	"./product-m-qrcode.png": "7404",
	"./product-m-step.png": "2729",
	"./product-m-table.png": "7268",
	"./product-m-tax.png": "5e34",
	"./product-m-val1.png": "bdde",
	"./product-m-val2.png": "24ac",
	"./product-m-val3.png": "92ca",
	"./product-one-0.png": "8a37",
	"./product-one-1.png": "7f9b",
	"./product-six-0.png": "1743",
	"./product-three-0.png": "138b",
	"./product-three-1.png": "0117",
	"./product-three-2.png": "9150",
	"./product/advantage-1.png": "0999",
	"./product/advantage-2.png": "9926",
	"./product/advantage-3.png": "30f6",
	"./product/advantage-4.png": "d2e5",
	"./product/dzjqr-aqsbns.png": "a981",
	"./product/dzjqr-ctcsh.png": "f8e0",
	"./product/dzjqr-cwbbgl.png": "9f6a",
	"./product/dzjqr-dzpzgl.png": "ea58",
	"./product/dzjqr-gsnj.png": "3add",
	"./product/dzjqr-gsnjtb.png": "72de",
	"./product/dzjqr-hsqjsb.png": "34ff",
	"./product/dzjqr-icon.png": "5503",
	"./product/dzjqr-phone.png": "c2d4",
	"./product/dzjqr-pjgl.png": "de1e",
	"./product/dzjqr-qr.png": "9951",
	"./product/dzjqr-xcbgl.png": "5960",
	"./product/dzjqr-xtzxzc.png": "ff1e",
	"./product/dzjqr-yhlsgl.png": "7fe2",
	"./product/pause.png": "81db",
	"./product/play.png": "b1d2",
	"./product/yszc-cm.png": "6a16",
	"./product/yszc-gs.png": "a5ca",
	"./product/yszc-gszc-cm.png": "be1c",
	"./product/yszc-gszc-gszc.png": "aa60",
	"./product/yszc-gszc-guide.png": "efd2",
	"./product/yszc-gszc-hm.png": "fa17",
	"./product/yszc-gszc-jyfw.png": "20ba",
	"./product/yszc-gszc-qm.png": "ad99",
	"./product/yszc-hm.png": "1173",
	"./product/yszc-icon.png": "28e8",
	"./product/yszc-jy.png": "bb9c",
	"./product/yszc-phone.png": "f838",
	"./product/yszc-qm.png": "7434",
	"./product/yszc-qr.png": "06f8",
	"./product/yszc-yhkh.png": "bc18",
	"./question-bg.png": "45c0",
	"./question-list-one-bg.png": "a104",
	"./question-list-one.png": "df48",
	"./service.png": "c046",
	"./side-app.png": "7641",
	"./side-online.png": "84ea",
	"./side-qywx.png": "553c",
	"./side-weixin.png": "6e02",
	"./solution/bank-banner-bg.png": "060f",
	"./solution/bank-industry-problem-icon.png": "e072",
	"./solution/bank-industry-problem-icon2.png": "ebca",
	"./solution/bank-industry-problem-icon3.png": "7dcf",
	"./solution/bank-nav-icon.png": "01a4",
	"./solution/cooperation-way-bg1.png": "fa01",
	"./solution/cooperation-way-bg2.png": "a4f6",
	"./solution/customer-banner-bg.png": "9cca",
	"./solution/customer-industry-problem-icon.png": "1ddd",
	"./solution/customer-industry-problem-icon2.png": "f4ee",
	"./solution/customer-nav-icon.png": "e90c",
	"./solution/partner-banner-bg.png": "48f3",
	"./solution/partner-industry-problem-icon.png": "e681",
	"./solution/partner-nav-icon.png": "14c7",
	"./solution/product-program-dzjqr-bottom.png": "5e3a",
	"./solution/product-program-phone-dzjqr.png": "1d00",
	"./solution/product-program-phone-ykp.png": "f18e",
	"./solution/product-program-phone-yszc.png": "4b3b",
	"./solution/product-program-switch-dzjqr.png": "4780",
	"./solution/product-program-switch-ykp.png": "3c6a",
	"./solution/product-program-switch-yszc.png": "150f",
	"./solution/product-program-ykp-icon1.png": "484f",
	"./solution/product-program-ykp-icon2.png": "92c7",
	"./solution/product-program-ykp-icon3.png": "606a",
	"./solution/product-program-yszc-icon1.png": "48fc",
	"./solution/product-program-yszc-icon2.png": "d382",
	"./solution/product-program-yszc-icon3.png": "523f",
	"./solution/product-program-yszc-icon4.png": "5950",
	"./special-bg.png": "5501",
	"./step-bg-m.png": "92fe",
	"./step-bg.png": "2835",
	"./step-custom-voice-bg.png": "5be5",
	"./step-customer-voice-slide-one-bg.png": "8b76",
	"./success-case.png": "02f2",
	"./tax-return.png": "1469",
	"./taxation.png": "4e83",
	"./tiyan.png": "33d5",
	"./tradition.png": "6f6c",
	"./upload-ticket.png": "444f",
	"./yy-success.png": "f5ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";